import { CourseContextProvider } from '@BUP/contexts/CourseContext'
import { CoursesContextProvider } from '@BUP/contexts/CoursesContext'
import { ASSISTANT, ECE, TEACHER } from '@BUP/constants'
import BraveupContextsComponent from './BraveupContextsComponent'

export const BraveupEnrollmentWrapper = ({ enrollment, role, roleLoading, children }) => {
  const roleType = role?.type

  const inner = (roleType === ECE || roleType === TEACHER)
    ? <CoursesContextProvider>{children}</CoursesContextProvider>
    : (roleType === ASSISTANT)
        ? children
        : <CourseContextProvider>{children}</CourseContextProvider>

  return (
    <BraveupContextsComponent
      enrollment={enrollment}
      role={role}
      roleLoading={roleLoading}
    >
      {inner}
    </BraveupContextsComponent>
  )
}
